import { Container, Flex, Paper, Text, Title } from '@mantine/core';

export default function VerificationSection() {
  return (
    <Container size="lg" py={{ base: 'xl', sm: '50', md: '60' }} px={{ base: 'md', sm: 'xl' }}>
      <Flex direction="column" align="center" gap="xs" mb={{ base: 'xl', md: '40' }}>
        <Title 
          order={2}
          fz={{ base: '24px', sm: '28px', md: '32px' }}
          ta="center"
          px={{ base: 'md', sm: 0 }}
        >
          Verification & Trust Framework
        </Title>
        <Text 
          ta="center" 
          maw={600}
          fz={{ base: 'sm', sm: 'sm', md: 'md' }}
          px={{ base: 'md', sm: 0 }}
        >
          Multi-layered verification process ensures only legitimate businesses join our network
        </Text>
      </Flex>

      <Flex direction="column" gap="md" maw={750} mx="auto">
        {[
          {
            num: '1',
            title: 'Document Submission',
            desc: 'Companies submit business registration, tax documents, and industry-specific certifications based on their country of operation.'
          },
          {
            num: '2',
            title: 'Compliance Review',
            desc: 'Our compliance team manually reviews all documents to verify authenticity and check against regulatory databases.'
          },
          {
            num: '3',
            title: 'Verification Badge',
            desc: 'Upon successful verification, companies receive a verified badge and can access the full platform including discovery and workspace features.'
          },
          {
            num: '4',
            title: 'Ongoing Monitoring',
            desc: 'We conduct periodic re-verification and monitor for any compliance issues to maintain trust across the network.'
          }
        ].map(step => (
          <Paper key={step.num} radius="md" p={{ base: 'md', sm: 'lg' }} style={{ backgroundColor: '#F8F9FA' }}>
            <Flex gap={{ base: 'xs', sm: 'md' }} align="flex-start">
              <Flex
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  backgroundColor: '#2563EB',
                  color: 'white',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                  flexShrink: 0
                }}
              >
                {step.num}
              </Flex>
              <Flex direction="column" gap={6}>
                <Text fw={600} fz={{ base: 'sm', md: 'md' }}>{step.title}</Text>
                <Text fz={{ base: 'xs', sm: 'sm' }}>{step.desc}</Text>
              </Flex>
            </Flex>
          </Paper>
        ))}
      </Flex>
    </Container>
  );
}